const booleanOptions = [
    { value: 1, label: "Yes" },
    { value: 2, label: "No" }
]
export default booleanOptions